import { InputControl, InputControlProps } from "formik-chakra-ui";

type Props = InputControlProps & { questionId: string };
export const InputControlWithQuestionId: React.FC<Props> = ({
  questionId,
  ...props
}) => {
  const id = `${props.name}-${questionId}`;
  return (
    <InputControl
      {...props}
      inputProps={{ ...props.inputProps, id }}
      labelProps={{ ...props.labelProps, htmlFor: id }}
    />
  );
};
